var Afghanistan = "Afganistán";
var Albania = "Albania";
var Algeria = "Argelia";
var Andorra = "Andorra";
var Angola = "Angola";
var Anguilla = "Anguila";
var Antarctica = "Antártida";
var Argentina = "Argentina";
var Armenia = "Armenia";
var Aruba = "Aruba";
var Australia = "Australia";
var Austria = "Austria";
var Azerbaijan = "Azerbaiyán";
var Bahamas = "Bahamas";
var Bahrain = "Baréin";
var Bangladesh = "Bangladesh";
var Barbados = "Barbados";
var Belarus = "Bielorrusia";
var Belgium = "Bélgica";
var Belize = "Belice";
var Benin = "Benín";
var Bermuda = "Bermudas";
var Bhutan = "Bután";
var Bolivia = "Bolivia";
var Botswana = "Botsuana";
var Brazil = "Brasil";
var Bulgaria = "Bulgaria";
var Burundi = "Burundi";
var Cambodia = "Camboya";
var Cameroon = "Camerún";
var Canada = "Canadá";
var Chad = "Chad";
var Chile = "Chile";
var China = "China";
var Colombia = "Colombia";
var Comoros = "Comoras";
var Congo = "Congo";
var Croatia = "Croacia";
var Cuba = "Cuba";
var Cyprus = "Chipre";
var Denmark = "Dinamarca";
var Djibouti = "Yibuti";
var Dominica = "Dominica";
var Ecuador = "Ecuador";
var Egypt = "Egipto";
var Eritrea = "Eritrea";
var Estonia = "Estonia";
var Ethiopia = "Etiopía";
var Fiji = "Fiyi";
var Finland = "Finlandia";
var France = "Francia";
var Gabon = "Gabón";
var Gambia = "Gambia";
var Georgia = "Georgia";
var Germany = "Alemania";
var Ghana = "Ghana";
var Gibraltar = "Gibraltar";
var Greece = "Grecia";
var Greenland = "Groenlandia";
var Grenada = "Granada";
var Guadeloupe = "Guadalupe";
var Guam = "Guam";
var Guatemala = "Guatemala";
var Guernsey = "Guernesey";
var Guinea = "Guinea";
var Guyana = "Guyana";
var Haiti = "Haití";
var Honduras = "Honduras";
var Hungary = "Hungría";
var Iceland = "Islandia";
var India = "India";
var Indonesia = "Indonesia";
var Iraq = "Irak";
var Ireland = "Irlanda";
var Israel = "Israel";
var Italy = "Italia";
var Jamaica = "Jamaica";
var Japan = "Japón";
var Jersey = "Jersey";
var Jordan = "Jordania";
var Kazakhstan = "Kazajistán";
var Kenya = "Kenia";
var Kiribati = "Kiribati";
var Kuwait = "Kuwait";
var Kyrgyzstan = "Kirguistán";
var Latvia = "Letonia";
var Lebanon = "Líbano";
var Lesotho = "Lesoto";
var Liberia = "Liberia";
var Libya = "Libia";
var Liechtenstein = "Liechtenstein";
var Lithuania = "Lituania";
var Luxembourg = "Luxemburgo";
var Macao = "Macao";
var Madagascar = "Madagascar";
var Malawi = "Malaui";
var Malaysia = "Malasia";
var Maldives = "Maldivas";
var Mali = "Mali";
var Malta = "Malta";
var Martinique = "Martinica";
var Mauritania = "Mauritania";
var Mauritius = "Mauricio";
var Mayotte = "Mayotte";
var Mexico = "México";
var Monaco = "Mónaco";
var Mongolia = "Mongolia";
var Montenegro = "Montenegro";
var Montserrat = "Montserrat";
var Morocco = "Marruecos";
var Mozambique = "Mozambique";
var Myanmar = "Myanmar";
var Namibia = "Namibia";
var Nauru = "Nauru";
var Nepal = "Nepal";
var Netherlands = "Países Bajos";
var Nicaragua = "Nicaragua";
var Niger = "Níger";
var Nigeria = "Nigeria";
var Niue = "Niue";
var Norway = "Noruega";
var Oman = "Omán";
var Pakistan = "Pakistán";
var Palau = "Palaos";
var Panama = "Panamá";
var Paraguay = "Paraguay";
var Peru = "Perú";
var Philippines = "Filipinas";
var Pitcairn = "Pitcairn";
var Poland = "Polonia";
var Portugal = "Portugal";
var Qatar = "Catar";
var Romania = "Rumanía";
var Rwanda = "Ruanda";
var Samoa = "Samoa";
var Senegal = "Senegal";
var Serbia = "Serbia";
var Seychelles = "Seychelles";
var Singapore = "Singapur";
var Slovakia = "Eslovaquia";
var Slovenia = "Eslovenia";
var Somalia = "Somalia";
var Spain = "España";
var Sudan = "Sudán";
var Suriname = "Surinam";
var Swaziland = "Esuatini";
var Sweden = "Suecia";
var Switzerland = "Suiza";
var Taiwan = "Taiwán";
var Tajikistan = "Tayikistán";
var Thailand = "Tailandia";
var Togo = "Togo";
var Tokelau = "Tokelau";
var Tonga = "Tonga";
var Tunisia = "Túnez";
var Turkey = "Turquía";
var Turkmenistan = "Turkmenistán";
var Tuvalu = "Tuvalu";
var Uganda = "Uganda";
var Ukraine = "Ucrania";
var Uruguay = "Uruguay";
var Uzbekistan = "Uzbekistán";
var Vanuatu = "Vanuatu";
var Venezuela = "Venezuela";
var Yemen = "Yemen";
var Zambia = "Zambia";
var Zimbabwe = "Zimbabue";
var countries = {
	"Country or region": "País o región",
	"United States": "Estados Unidos",
	Afghanistan: Afghanistan,
	"Åland Islands": "Islas Åland",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "Samoa Americana",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "Antigua y Barbuda",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "Bosnia y Herzegovina",
	Botswana: Botswana,
	"Bouvet Island": "Isla Bouvet",
	Brazil: Brazil,
	"British Indian Ocean Territory": "Territorio Británico del Océano Índico",
	"Brunei Darussalam": "Brunéi Darusalam",
	Bulgaria: Bulgaria,
	"Burkina Faso": "Burkina Faso",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "Cabo Verde",
	"Cayman Islands": "Islas Cayman",
	"Central African Republic": "República Centroafricana",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "Isla de Navidad",
	"Cocos (Keeling) Islands": "Islas Cocos",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "Congo, República Democrática del",
	"Cook Islands": "Islas Cook",
	"Costa Rica": "Costa Rica",
	"Côte d'Ivoire": "Costa de Marfil",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "República Checa",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "República Dominicana",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "El Salvador",
	"Equatorial Guinea": "Guinea Ecuatorial",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "Islas Malvinas (Falkland)",
	"Faroe Islands": "Islas Feroe",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "Guayana Francesa",
	"French Polynesia": "Polinesia Francesa",
	"French Southern Territories": "Territorios Australes Franceses",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "Guinea-Bisáu",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "Islas Heard y McDonald",
	"Holy See (Vatican City State)": "Santa Sede (Estado de la Ciudad del Vaticano)",
	Honduras: Honduras,
	"Hong Kong": "Hong Kong",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "Irán, República Islámica de",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "Isla de Man",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "Corea, República Popular Democrática de",
	"Korea, Republic of": "Corea, República de",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "Laos, República Democrática Popular de",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "Macedonia, Antigua República Yugoslava de",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "Islas Marshall",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "Micronesia, Estados Federados de",
	"Moldova, Republic of": "Moldavia, República de",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "Antillas Holandesas",
	"New Caledonia": "Nueva Caledonia",
	"New Zealand": "Nueva Zelanda",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "Isla Norfolk",
	"Northern Mariana Islands": "Islas Marianas del Norte",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "Territorio Palestino Ocupado",
	Panama: Panama,
	"Papua New Guinea": "Papúa Nueva Guinea",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "Puerto Rico",
	Qatar: Qatar,
	"Réunion": "Reunión",
	Romania: Romania,
	"Russian Federation": "Federación de Rusia",
	Rwanda: Rwanda,
	"Saint Helena": "Santa Elena",
	"Saint Kitts and Nevis": "San Cristóbal y Nieves",
	"Saint Lucia": "Santa Lucía",
	"Saint Pierre and Miquelon": "San Pedro y Miquelón",
	"Saint Vincent and The Grenadines": "San Vicente y las Granadinas",
	Samoa: Samoa,
	"San Marino": "San Marino",
	"Sao Tome and Principe": "Santo Tomé y Príncipe",
	"Saudi Arabia": "Arabia Saudí",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "Sierra Leona",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "Islas Salomón",
	Somalia: Somalia,
	"South Africa": "Sudáfrica",
	"South Georgia and The South Sandwich Islands": "Islas Georgias del Sur y Sandwich del Sur",
	Spain: Spain,
	"Sri Lanka": "Sri Lanka",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "Svalbard y Jan Mayen",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "República Árabe Siria",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "Tanzania, República Unida de",
	Thailand: Thailand,
	"Timor-Leste": "Timor Oriental",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "Trinidad y Tobago",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "Islas Turcas y Caicos",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "Emiratos Árabes Unidos",
	"United Kingdom": "Reino Unido",
	"United States Minor Outlying Islands": "Islas menores alejadas de los Estados Unidos",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "Vietnam",
	"Virgin Islands, British": "Islas Vírgenes Británicas",
	"Virgin Islands, U.S.": "Islas Vírgenes de los Estados Unidos",
	"Wallis and Futuna": "Wallis y Futuna",
	"Western Sahara": "Sáhara Occidental",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
